<template>
  <ContactsPage />
</template>

<script setup lang="ts">
import { generatePageMetaLinks } from '~/core/seo'
import { ContactsPage } from '~/features/contacts'

definePageMeta({
  layout: 'back-button',
})

useHead({
  link: generatePageMetaLinks(),
})
</script>
